import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { products } from '../../data/products';
import { useCart } from '../../context/CartContext';
import './ProductList.css';

const SCROLL_KEY = 'pl_scroll_y';

const renderStars = (rating) => {
  const full = Math.floor(rating);
  const half = rating % 1 >= 0.5;
  return '★'.repeat(full) + (half ? '½' : '') + '☆'.repeat(5 - full - (half ? 1 : 0));
};

const formatPrice = (price) => '৳' + price.toLocaleString('en-BD');

const ProductList = () => {
  const navigate = useNavigate();
  const { totalItems } = useCart();

  // Restore scroll position when coming back from a product page
  useEffect(() => {
    const saved = sessionStorage.getItem(SCROLL_KEY);
    if (saved) {
      window.scrollTo({ top: parseInt(saved, 10), behavior: 'instant' });
      sessionStorage.removeItem(SCROLL_KEY);
    }
  }, []);

  const handleCardClick = (id) => {
    sessionStorage.setItem(SCROLL_KEY, window.scrollY);
    navigate(`/product/${id}`);
  };

  return (
    <div className="pl-page">
      <header className="pl-header">
        <div className="pl-header-brand">
          <span>FashionAR</span>
        </div>
        <div className="pl-header-actions">
          <button className="pl-header-link" onClick={() => navigate('/orders')}>My Orders</button>
          <button className="pl-cart-btn" onClick={() => navigate('/cart')}>
            🛒
            {totalItems > 0 && <span className="pl-cart-badge">{totalItems}</span>}
          </button>
        </div>
      </header>

      <div className="pl-hero">
        <h1>Try Before You <span>Buy</span></h1>
        <p>Browse our collection and virtually try on any item using Snap AR — right from your browser.</p>
      </div>

      <main className="pl-main">
        <div className="pl-section-title">All Products ({products.length})</div>
        <div className="pl-grid">
          {products.map((product) => {
            const discountedPrice = product.discount
              ? Math.round(product.price * (1 - product.discount / 100))
              : product.price;

            return (
              <div
                key={product.id}
                className="pl-card"
                onClick={() => handleCardClick(product.id)}
              >
                <div className="pl-card-img-wrap">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="pl-card-img"
                    loading="lazy"
                  />
                  {product.discount && (
                    <span className="pl-badge-discount">{product.discount}% OFF</span>
                  )}
                  <span className="pl-badge-ar">AR TRY-ON</span>
                </div>

                <div className="pl-card-body">
                  <div className="pl-card-category">{product.category}</div>
                  <div className="pl-card-name">{product.name}</div>

                  <div className="pl-card-pricing">
                    <span className="pl-price-current">{formatPrice(discountedPrice)}</span>
                    {product.discount && (
                      <span className="pl-price-original">{formatPrice(product.price)}</span>
                    )}
                  </div>

                  <div className="pl-card-rating">
                    <span className="pl-stars">{renderStars(product.rating)}</span>
                    <span>{product.rating}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
};

export default ProductList;
